import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth, StrongText } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { draftPrescriptionsTranslationKeys } from '../../../../../../../translations';

import { PatientInPersonExaminationRequiredModalConfirmButton } from './PatientInPersonExminationRequiredModalConfirmButton';

type PatientInPersonExaminationRequiredModalProps = {
   onClose: VoidFunction;
   onPatientInPersonExaminationConfirmed: PromiseVoidFunction;
   visitId: number;
};

export const PatientInPersonExaminationRequiredModal = (
   props: PatientInPersonExaminationRequiredModalProps
): ReactElement => {
   return (
      <Modal
         width={ModalWidth.NORMAL}
         testId={'patientInPersonExaminationRequiredModal'}
         title={draftPrescriptionsTranslationKeys.prescriptionRequirePatientInPersonExamination}
      >
         <span>
            <Trans
               i18nKey={draftPrescriptionsTranslationKeys.atLeastOneMedicineRequiresPatientInPersonExamination}
               components={{
                  bold: <StrongText testId={'patientInPersonExaminationConfirmation'} />,
               }}
            />
         </span>
         <PatientInPersonExaminationRequiredModalConfirmButton
            onSuccess={props.onPatientInPersonExaminationConfirmed}
            onClose={props.onClose}
            visitId={props.visitId}
         />
         <ModalCloseButton onClick={props.onClose} />
         <ModalCancelButton onClick={props.onClose} />
      </Modal>
   );
};
